import apiUrl from "../../../constants";
import axios from "axios";
import CryptoJS from "crypto-js";
import Paginate from "vuejs-paginate";
import { Validator } from "vee-validate";
import VueAlertify from 'vue-alertify';
import VueElementLoading from 'vue-element-loading';
import PageTracker from '../../../common/PageTrackerHelper'

export default {
  name: "agentShowHandOverReturnShipment",
  components: { Paginate,VueElementLoading },
  props: [],
  mixins:[PageTracker],
  data() {
    return {
      pagecount: 0,
      pageno: 0,
      fromDate: new Date().toISOString().split("T")[0],
      toDate: new Date().toISOString().split("T")[0],
      processmode: "",
      status: "",
      returnArray: [],
      agentDetailss: [],
      agentShipmentDetails: [],
      handoverArray:[],
      returnArray:[],
      statusArray:[],
      tempStatusArray:[],
      statusObj:{},
      isLoading: false,
      localusermailid: '',
      userDataKey : '',
    };
  },
  computed: {
  },
  async mounted() {
    this.userDataKey = window.localStorage.getItem('userUniqueKey');
    let validateUser = await this.validateJwtToken();
    this.getIntializeValue();
    var userdetailEncrypt = window.localStorage.getItem('lmaccessuserdata')
    var bytes = CryptoJS.AES.decrypt(userdetailEncrypt.toString(), this.userDataKey);
    var plaintext = bytes.toString(CryptoJS.enc.Utf8);
    var userdetail = JSON.parse(plaintext);

    this.localuserid = userdetail.userid;
    this.outsourcingid = userdetail.outsourcingid;
    this.localusermailid = userdetail.email;

    // let TrackerInfo = {
    //     projectname:"Last Mile",
    //     type:"Web",
    //     userid:this.localuserid,
    //     username:this.localusermailid,
    //     meta: {
    //         "event":""
    //     }
    // }
    // let result  = this.PageTracker(TrackerInfo);
  },
  methods: {
    searchAgent() {
      this.isLoading = true;
      let obj = {
        fromDate: this.fromDate,
        toDate: this.toDate,
        processmode: this.processmode,
        status: this.status,
        offset: this.pageno,
        outsourcingid: this.outsourcingid,
        limit: 1000
      };
      axios({
        method: "POST",
        url:  apiUrl.api_url + 'AgentHandoverDashboard/getAllAgentShipmentDetails',
        data: obj,
        header: {
          "content-type": "application/json"
        }
      }).then(
        result => {
          if(result.data.code==200){
            this.returnArray = result.data.data;
            let totalRows = result.data.count;
            this.resultCount = result.data.data.length;
            if (this.resultCount < 10) {
              this.pagecount = 1;
            } else {
              this.pagecount = Math.ceil(totalRows / 10);
            }
            this.showTable = true;
          } else {
            this.returnArray = [];
          }
          this.isLoading = false;
        },
        error => {
          console.error("error:", error);
          this.isLoading = false;
        }
      );
    },
    getAgentShipmentDetails(id, handovermode, hubid) {
      let obj = {
        batchid: id,
        processmode: handovermode,
        hubid: hubid
      };
      axios({
        method: "POST",
        url:  apiUrl.api_url + 'AgentHandoverDashboard/getAgentShipmentDetails',
        data: obj,
        header: {
          "content-type": "application/json"
        }
      }).then(
        result => {
          this.agentShipmentDetails = result.data.data;
          this.showTable = true;
        },
        error => {
          console.error("error:", error);
        }
      );
    },
    getPaginationData(pageNum) {
      this.pageno = (pageNum - 1) * 10;
      this.searchAgent();
    },
    onDateChange(){
      this.pageno=0;
      let fromD=new Date(this.fromDate);
      let toD=new Date(this.toDate);
      if(fromD>toD){
        this.$alertify.alert("Date alert","To date should be greater than from date.");
      }
    },
    downloadShipmentData(){
      this.isLoading = true;
      if(this.returnArray==undefined || this.returnArray.length==0){
        this.$alertify.alert("No data","No data available for download.");
      }
      this.getDownloadCsvObject(this.returnArray);
      this.isLoading = false;
      //console.log('helo');
    },
    getDownloadCsvObject(result) {
      var csvData = result;
      var today = new Date();
      var dd = today.getDate();
      var mm = today.getMonth() + 1;
      var yyyy = today.getFullYear();
      var today = dd + "" + mm + "" + yyyy;
      var data, filename, link;
      filename = "HandoverShipmentData_" + today + ".csv";
      var csv = this.convertArrayOfObjectsToCSV({
        data: csvData
      });
      if (csv == null) return;
      filename = filename || "export.csv";
      if (!csv.match(/^data:text\/csv/i)) {
        csv = "data:text/csv;charset=utf-8," + csv;
      }
      data = encodeURI(csv);
      link = document.createElement("a");
      link.setAttribute("href", data);
      link.setAttribute("download", filename);
      document.body.appendChild(link);
      link.click();
      //link.removeChild(link);
    },
    convertArrayOfObjectsToCSV: function(args) {
      var result, ctr, keys, columnDelimiter, lineDelimiter, data;
      data = args.data || null;
      if (data == null || !data.length) {
        return null;
      }
      columnDelimiter = args.columnDelimiter || ",";
      lineDelimiter = args.lineDelimiter || "\n";
      keys = Object.keys(data[0]).slice(0);
      result = "";
      result += keys.join(columnDelimiter);
      result += lineDelimiter;
      data.forEach(function(item) {
        ctr = 0;
        keys.forEach(function(key) {
          if (ctr > 0) result += columnDelimiter;
          if (item[key] != null) {
            result += '"' + item[key] + '"';
          }
          ctr++;
        });
        result += lineDelimiter;
      });
      return result;
   },
   getStatuses(processmode){
     let obj = {
       reasonType: processmode
     };
     axios.get(apiUrl.api_url + `external/getreasons?reasonType=${processmode}`, obj)
       .then((result) => {
         this.statusArray=[];
         this.tempStatusArray = result.data.data;
         this.tempStatusArray.forEach(obj =>{
           let statusObj={
             status:obj.Reason
           };
           this.statusArray.push(statusObj);
         });
         this.showTable = true;
       })
       .catch((httpException) => {
             this.$alertify.success("Status data not found");
             console.error('exception is:::::::::', httpException)
       })

   },
   // getStatuses(processmode){
   //   let obj = {
   //     ReasonType: processmode
   //   };
   //   axios({
   //     method: "POST",
   //     url: apiUrl.master_api_url + "expose/reason/get/reasondetailsbytype",
   //     data: obj,
   //     header: {
   //       "content-type": "application/json",
   //       "versionnumber" : "v1",
   //       "token" : "xyz"
   //     }
   //   }).then(
   //     result => {
   //       this.statusArray=[];
   //       this.tempStatusArray = result.data.data;
   //       this.tempStatusArray.forEach(obj =>{
   //         let statusObj={
   //           status:obj.Reason
   //         };
   //         this.statusArray.push(statusObj);
   //       });
   //       this.showTable = true;
   //     },
   //     error => {
   //       console.error("error:", error);
   //     }
   //   );
   // },
   processOnChange(){
     this.pageno=0;
     this.status="";
     let processmode=this.processmode;
     this.getStatuses(processmode);
   },
   statusOnChange(){
     this.pageno=0;
   },
   fromDateChange(){
     this.pageno=0;
   },

    onSubmit: function(scope) {
      //console.log(event);
      this.$validator
        .validateAll(scope)
        .then(result => {
          console.log('result',result);

          if (!result) {
            return false;
          }else {
            this.searchAgent();
          }
        })
        .catch(() => {
          console.log("errors exist", this.errors);
        });
    },
    resetForm() {
      this.agentShipmentDetails = [];
      this.returnArray = [];
      this.processmode = "Handover";
      this.fromDate = "";
      this.toDate = "";
      this.getStatuses(this.processmode);
      this.isLoading = false;
    },
    getIntializeValue() {
      this.agentShipmentDetails = [];
      this.returnArray = [];
      this.processmode = "Handover";
      this.status="",
      this.fromDate = new Date().toISOString().split("T")[0];
      this.toDate = new Date().toISOString().split("T")[0];
      this.getStatuses(this.processmode);
    }
  }
};



// WEBPACK FOOTER //
// ./src/views/components/agentShowHandOverReturnShipment/agentShowHandOverReturnShipment.component.js